module.exports = __webpack_public_path__ + "img/architecture2.59c295b1.jpg";